export default __webpack_public_path__ + "static/media/za.535932d3.svg";